var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAguaConsumo = function SvgAguaConsumo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4189 3.29738C11.6302 3.00396 12.0528 2.90616 12.3698 3.10177C12.4491 3.15067 12.5283 3.22402 12.5811 3.29738C12.9509 3.81085 13.3472 4.37323 13.7962 4.98451C15.883 7.82084 19 12.0753 19 14.5204C19 16.3054 18.2075 17.9192 16.9396 19.0928C15.6717 20.2665 13.9283 21 12 21C10.0717 21 8.3283 20.2665 7.06038 19.1173C5.79245 17.9436 5 16.3298 5 14.5449C5 12.0998 8.11698 7.82084 10.2038 4.98451C10.6792 4.34878 11.0755 3.81085 11.4189 3.29738ZM15.9997 14.0003C15.0006 14.0003 15.0006 14.9997 15.0006 14.9997C15.0006 16.081 14.1243 17.001 12.9997 17.001C12.9997 17.001 11.9997 17.006 11.9997 18.0028C11.9997 18.9997 12.9997 18.9997 12.9997 18.9997C15.2088 18.9997 16.9997 17.2088 16.9997 14.9997C16.9997 14.9997 16.9987 14.0003 15.9997 14.0003Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAguaConsumo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/agua-consumo.d50d9d7a.svg";
export { ForwardRef as ReactComponent };